import Actions from '../../odata/actions';

const actions = new Actions('taxRate', 'taxRates');

export default actions;
